// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f5817c89","522":"59992dfb","570":"f9ad8d68","581":"5bc069ca","689":"52d963be","692":"73521bb5"}[chunkId] + ".chunk.js";
};